export enum PurposeType {
  COMMERCIAL_USE = 'commercial_use',
  PERSONAL_USE = 'personal_use',
  RETURN_GOODS = 'return_goods',
  SAMPLE = 'sample_use',
}
